import { createAction, EmptyActionCreator } from 'redux-act';

const MODULE_ID = 'ROUTER_';

const createRouterAction = <T>(type: string) =>
  createAction<T>(`${MODULE_ID}${type}`);

export const updateRouterState =
  createRouterAction<WebOrder.State.Location>('UPDATE_STATE');

export const navigate = createRouterAction<WebOrder.State.Location>('NAVIGATE');
export const navigateBack = createRouterAction(
  'NAVIGATE_BACK',
) as EmptyActionCreator;
